import { uploadFile, deleteFile } from '../firebase';

export const uploadPromoImage = async (file: File): Promise<string> => {
  try {
    // Generate a unique filename with timestamp
    const timestamp = Date.now();
    const fileExt = file.name.split('.').pop();
    const fileName = `promo_${timestamp}.${fileExt}`;
    const filePath = `images/promos/${fileName}`;
    
    // Upload the file to Firebase Storage
    const downloadURL = await uploadFile(file, filePath);
    return downloadURL;
  } catch (error) {
    console.error('Error uploading promo image:', error);
    throw new Error('Error al subir la imagen. Por favor, intente nuevamente.');
  }
};

export const deletePromoImage = async (imageUrl: string): Promise<void> => {
  try {
    // Extract the file path from the download URL
    const matches = imageUrl.match(/images%2Fpromos%2F[^?]+/);
    if (matches) {
      const filePath = decodeURIComponent(matches[0]);
      await deleteFile(filePath);
    }
  } catch (error) {
    console.error('Error deleting promo image:', error);
    // Don't throw the error to prevent blocking the main operation
  }
};
